import MatrixRain from "@/components/MatrixRain";
import SelenaMatrix from "@/components/SelenaMatrix";
import TokenBank from "@/components/TokenBank";
import AmbassadorOffer from "@/components/AmbassadorOffer";
import PaymentSection from "@/components/PaymentSection";
import { useI18n } from "@/contexts/I18nContext";

export default function Studio() {
  const { t, lang } = useI18n();

  return (
    <>
      <section data-testid="studio-page" className="dncm-stage min-h-[100vh] pt-28 pb-8">
        <div className="absolute inset-0 opacity-25 pointer-events-none">
          <MatrixRain density={0.5} speed={0.6} opacity={0.55} />
        </div>
        <div className="absolute inset-0 dncm-grid-bg pointer-events-none" />

        <div className="dncm-content max-w-7xl mx-auto px-6 lg:px-10">
          <header className="max-w-3xl">
            <div className="flex items-center gap-3 mb-6">
              <span className="dncm-pulse-dot" style={{ background: "var(--dncm-green)", boxShadow: "0 0 12px var(--dncm-green)" }} />
              <span className="font-mono-d text-[11px] uppercase tracking-[0.32em] text-white/65">
                Studio
              </span>
            </div>
            <h2 data-testid="studio-title" className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-tight">
              {lang === "fr" ? (
                <>
                  Configurez votre
                  <br />
                  <span className="dncm-gradient-text">empire IA</span>.
                </>
              ) : (
                <>
                  Configure your
                  <br />
                  <span className="dncm-gradient-text">AI empire</span>.
                </>
              )}
            </h2>
            <p className="mt-6 text-white/70 max-w-2xl text-base sm:text-lg">{t("studio_subtitle")}</p>
          </header>
        </div>
      </section>

      <SelenaMatrix />
      <TokenBank />
      <AmbassadorOffer />
      <PaymentSection onActivate={() => {
        const el = document.getElementById("ambassador");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }} />
    </>
  );
}
